import { render, staticRenderFns } from "./Currency.vue?vue&type=template&id=44607c81&scoped=true"
import script from "./Currency.vue?vue&type=script&lang=js"
export * from "./Currency.vue?vue&type=script&lang=js"
import style1 from "./Currency.vue?vue&type=style&index=1&id=44607c81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44607c81",
  null
  
)

export default component.exports